export default "__VITE_ASSET__B2JEs3Yp__"